import React from 'react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'
import MasterClassRoutes from './Constants/routes'

const MasterClass = () => {
  const match = useRouteMatch()
  return (
    <>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
        {MasterClassRoutes.map(({ path, Component, id, exact }) => (
          <Route
            path={`${match.url}${path}`}
            component={Component}
            exact={exact}
            key={id}
          />
        ))}
        <Redirect to="/dashboard/courses" />
      </Switch>
    </>
  );
}

export default MasterClass